export enum DataTypeDateData {
    STRING,
    DATE,
}